export const SET_ERROR_FACEBOOK_LOGIN = 'social/SET_ERROR_FACEBOOK_LOGIN';
export const SET_ERROR_GOOGLE_LOGIN = 'social/SET_ERROR_GOOGLE_LOGIN';
export const SET_ERROR_TOOLBOX_LOGIN = 'social/SET_ERROR_TOOLBOX_LOGIN';
export const POST_GOOGLE_LOGIN = 'saga/social/POST_GOOGLE_LOGIN';
export const POST_FACEBOOK_LOGIN = 'saga/social/POST_FACEBOOK_LOGIN';
export const POST_TOOLBOX_LOGIN = 'saga/social/POST_TOOLBOX_LOGIN';
